import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { UserDataService } from '../../features/user-data.service';

@Component({
  selector: 'app-inventor-recording',
  templateUrl: './inventor-recording.component.html',
  styleUrls: ['./inventor-recording.component.css']
})
export class InventorRecordingComponent implements OnInit {

  visible=false;
  token:any;
  record:any;
  userWithToken:any;
  error:any;
  searchText:any;
  users:any;
  companies:any;
  inventorCompany={name:"xxx",adress:"yyy"};
  invComp=false;
  loggedUser="";
  toggle=true;

  inventorName="";
  inventorAdress="";
  inventorMail="";
  inventorIdentityNo="";
  inventorStatus="";
  constructor(private userData:UserDataService, private auth:AuthService, private route:Router ){}
   aslan=true;



    ngOnInit() {


     this.token=this.auth.token;
     this.loggedUser=this.auth.userMail;
     }
     ngAfterContentInit(): void {
      this.userData.fetchCompany(this.token).subscribe(
        (res: any) => {
         if (!res) {
           this.record="Buluş Sahibi bulunamadı";
           alert("Buluş Sahibi bulunamadı")
         } else {

        // console.log(res);
         this.userWithToken=res;
         this.companies = Object.keys(res).map((key) =>
         { return res[key] });

         this.companies.key = Object.keys(res).map((key) =>
         { return (key) });

       //  console.log(this.companies);
         this.record=""
       }},err=>this.error=(err.statusText)
     );
     }








  findInventor() {
    this.visible=!this.visible;
    this.userData.fetchInventor(this.token).subscribe(
     (res: any) => {
      if (!res) {
        this.record="Buluş Sahibi Bulunamadı";
        alert("Buluş Sahibi bulunamadı")
      } else {

    //  console.log(res);
      this.userWithToken=res;
      this.users = Object.keys(res).map((key) =>
      { return res[key] });

      this.users.key = Object.keys(res).map((key) =>
      { return (key) });

      console.log(this.users);
      this.record=""
    }},err=>this.error=(err.statusText)
  );
  }
  removeInventor(i:number) {
    if(confirm(this.users[i][0].inventorName+" adlı Buluş Sahibinin kaydı silinecektir. Onaylıyor musunuz?")){
 //   console.log(this.users[i]);
   /* this.userData.deletionRecords([this.loggedUser,Date.now()],"Buluş Sahibi kaydı silindi",this.users[i][0]).subscribe();*/
   // console.log(this.loggedUser);
    /* this.http.delete('https://sisecam-a8421-default-rtdb.firebaseio.com/patents/'+ this.users.key[i] +'.json?auth='+this.token).subscribe(res=>{console.log(res)},err=> this.error=(err.statusText));*/
    this.userData.deletionRecords([this.loggedUser,Date.now()],'Buluş Sahibi kaydı silindi', `Silinen Buluş Sahibi: ${this.users[i][0].inventorName} `).subscribe();
    alert('Buluş Sahibi kaydı silindi');
    this.userData.removeInventor(this.users.key[i]);
       this.redirectTo('masterData');
    }


  }
  redirectTo(uri:string){
    this.route.navigateByUrl('/', {skipLocationChange: true}).then(()=>
    this.route.navigate([uri]));
 }
 inventorsCompany(i:any,j:any) {
 // console.log(i);
  this.inventorCompany={name:i, adress:j};

  this.invComp=true;
 }

    submit() {
        var record=[];
        this.toggle=false;
        this.inventorName=this.inventorName?.toLowerCase();
        this.inventorAdress=this.inventorAdress?.toLowerCase();
        this.inventorMail=this.inventorMail?.toLowerCase();
        this.inventorIdentityNo=this.inventorIdentityNo?.toLowerCase();
        this.inventorStatus=this.inventorStatus?.toLowerCase();


        record.push({recordingUser:this.loggedUser, date:Date.now()});

            this.userData.addInventor(
                            this.inventorName,
                            this.inventorAdress,
                            this.inventorMail,
                            this.inventorIdentityNo,
                            this.inventorStatus,
                            this.inventorCompany,
                            record
                            ).
                            subscribe(arr=>{
                             // console.log(arr);
                              this.record="Buluş Sahibi Kaydedildi";
                              alert("Buluş Sahibi kaydedildi")
                            },
                            err=>{
                            this.error=err.statusText;
                            console.log(this.error)});
                            this.users=[];

  }
}
